export default "__VITE_ASSET__86Ar5dvR__"